import axios from "axios";
import env from "../Env";
import moment from "moment";
export default {
  generateSoW: function (token, lawfirm, sowData) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}${lawfirm}/sows`;
      axios
        .put(url, sowData, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getAmendmentClients: function(token, searchText) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}${searchText}`;
      axios
        .get(url, { headers: { Authorization: token } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  trash: function (token, sow) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}sows/${sow}/trash`;
      axios
        .post(url, {}, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  finalize: function (token, sow) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}sows/${sow}/finalize`;
      axios
        .post(url, {}, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getSows: function (token, sowFilter) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}sow/getall`;
      axios
        .post(url, sowFilter, { headers: { Authorization: `${token}` } })
        .then(response => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getAmendmentSows: function (token, id) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}${id}/amendmentsows?${t}`;
      axios
        .get(url, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  download: function (token, fileId, fileName) {
    return new Promise(resolve => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}sow/${fileId}/downloadtemplate/${fileName}`;
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: `${token}` },
      }).then(response => {
        resolve(response);
      });
    });
  },
  downloadMSA: function (token, fileId, fileName) {
    return new Promise(resolve => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}sow/${fileId}/downloadtemplate/${fileName}`;
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: `${token}`},
      }).then(response => {
        resolve(response);
      });
    });
  },
  getSowClients: function (token, country) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}${country}/sowclients?${t}`;
      axios
        .get(url, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getClientSows: function (token, clientName) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let cname = "'" + clientName + "'";
      let url = `${process.env.VUE_APP_baseUrl}${cname}/clientsows?${t}`;
      axios
        .get(url, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  getRateCardDetails:function (token, sowData) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}ratecard?${t}`;
      axios
        .post(url,sowData, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  validateRateCard: function(token, ratecardid) {
    return new Promise((resolve, reject) => {
      let url = `${process.env.VUE_APP_baseUrl}sow/${ratecardid}/ratecardid`;
      axios
        .get(url, { headers: { Authorization: token } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
};
